/* eslint-disable import/prefer-default-export */
import { ReportTypeEnum } from '@src/endpoints/openapis/saas-cam-reportmanager'

export const unknownTypeTitle = 'Unknown'

export const reportTypeTitles: { [key in ReportTypeEnum]: string } = {
  [ReportTypeEnum.UnusedAccessRoleSummary]: 'Unused Roles',
  [ReportTypeEnum.UnusedAccessRoleByServiceSummary]: 'Unused Roles by Service',
  [ReportTypeEnum.UnusedAccessRoleByPrivilegeSummary]:
    'Unused Roles by Privilege',
  [ReportTypeEnum.UnusedAccessIdentitySummary]: 'Unused Identities w/ Role',
  [ReportTypeEnum.UnusedAccessIdentityByServiceSummary]:
    'Unused Identities w/ Role by Service',
  [ReportTypeEnum.UnusedAccessIdentityByPrivilegeSummary]:
    'Unused Identities w/ Role by Privilege',
  [ReportTypeEnum.UnusedAccessIdentityWithoutRoleSummary]:
    'Unused Identities w/o Role',
  [ReportTypeEnum.UnusedAccessIdentityWithoutRoleByServiceSummary]:
    'Unused Identities w/o Role by Service',
  [ReportTypeEnum.UnusedAccessIdentityWithoutRoleByPrivilegeSummary]:
    'Unused Identities w/o Role by Privilege',
  [ReportTypeEnum.Unknown]: unknownTypeTitle
}
